import React, { useState } from "react";
import { loginBack } from "helper/constant";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import enhancer from "./enhancer/RegisterFormEnhancer";
import { merchantRegister, userRegister } from "services/userProfileServices";
import { connect } from "react-redux";
import navigationAction from "redux/navigation/actions";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import Loader from "components/Loader";

const { success, error } = navigationAction;
const Register = props => {
  let {
    isValid,
    handleSubmit,
    handleChange,
    handleBlur,
    errors,
    touched,
    submitCount,
    values,
    setValues
  } = props;
  const [togglePassword, setTogglePassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleRegister = async e => {
    e.preventDefault();
    handleSubmit();
    if (isValid) {
      setLoading(true);

      // console.log("Here is your form value", values);
      let data = {
        ...values,
        is_superadmin: false,
        user_status: true
      };
      await merchantRegister(data).then(res => {
        if (res.success) {
          success(res.message);
          setLoading(false);
          props.history.push("/admin/login");
        } else {
          error(res.message);
          setLoading(false);
        }
      });
    }
  };

  const loginContainer = {
    backgroundImage: `url(${loginBack})`,
    backgroundPosition: "center center",
    backgroundSize: "cover",
    position: "fixed",
    overflow: "auto",
    top: 0,
    bottom: 0
  };

  const Error = props => {
    const field1 = props.field;
    if ((errors[field1] && touched[field1]) || submitCount > 0) {
      return (
        <span className={props.class ? props.class : "error-msg"}>
          {errors[field1]}
        </span>
      );
    } else {
      return <span />;
    }
  };

  return (
    <div className="container-fluid" style={loginContainer}>
      <div className="form-align">
        <div className="form-container register-form">
          <div className="login-icon">
            {/* <img src={iconDemo} alt="icon" height="100px" /> */}
          </div>
          <div className="login-title">Create Account</div>
          <form className="pa-24">
            <div className="form-group">
              <label>Name</label>
              <input
                type="text"
                className="form-control react-form-input"
                id="name"
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="Name"
              />
              <Error field="name" />
            </div>

            {/* <div className="form-group">
              <label>Last Name</label>
              <input
                type="text"
                className="form-control react-form-input"
                id="lastname"
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="Last Name"
              />
              <Error field="lastname" />
            </div> */}
            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                className="form-control react-form-input"
                id="email"
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="Email"
              />
              <Error field="email" />
            </div>

            <div className="form-group">
              <label>Phone Number:</label>
              <input
                type="text"
                className="form-control react-form-input"
                id="phone_number"
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="Phone Number"
              />
              <Error field="phone_number" />
            </div>

            <div className="input-group mb-3">
              <input
                type={togglePassword ? "text" : "password"}
                className="form-control react-form-input"
                id="password"
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="Confirm Password"
              />
              <div className="input-group-append register-input">
                {togglePassword ? (
                  <VisibilityOff onClick={() => setTogglePassword(false)} />
                ) : (
                  <Visibility
                    onClick={() => {
                      setTogglePassword(true);
                      // console.log("clicked");
                    }}
                  />
                )}
              </div>
            </div>
            <Error field="password" />

            <div className="form-check text-center mtb-16">
              <input
                type="checkbox"
                className="form-check-input"
                id="exampleCheck1"
                checked={values.terms_condition}
                onChange={e => {
                  setValues({ ...values, terms_condition: e.target.checked });
                }}
              />
              <label
                className="form-check-label register-privacy-text"
                htmlFor="exampleCheck1"
              >
                Agree to <a href="/register">terms & privacy policy</a>
              </label>
            </div>
            <Error field="terms_condition" />

            <button
              className="btn form-button siteenterbutton"
              onClick={() => handleRegister()}
            >
              Register
            </button>
            <div
              className="text-center link-label"
              onClick={() => props.history.push("/admin/login")}
            >
              Login ?
            </div>
          </form>
        </div>
        {loading && <Loader />}
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  // console.log(state);
  return {
    token: state.auth.accessToken
    // user: state.auth.user,
    // isFetching: state.navigation.isFetching
  };
};

export default compose(
  withRouter,
  enhancer,
  connect(mapStateToProps, {
    success,
    error
  })
)(Register);

// export default compose(withRouter, enhancer)(Register);
